<!--
FORMULARIO COM DADOS ADICIONAIS DO PEDIDO DE VENDA
-->

<script>
import { SysVars } from '../main';
import { formatValue } from '../shared/utils'
import CustomerForm from '../forms/customer-form'
import CustomerContatoForm from '../forms/customer-contato-form'
import VendForm from '../forms/vend-form'

export default {
    props: {
        pedv: {type: Object},
        partCodTabpre: {type: String},
        metadata: {type: Object},
        isView: {type: Boolean}
    },

    data () {
        return {
            showPartForm: false, //exibe o formulario de cliente para inclusao
            showVendForm: false, //exibe o formulario de vendedor para inclusao
            showContatoForm: false, //exibe o formulario de contato do cliente para inclusao
        }
    },

    computed: {
        administrador: function () {
            return SysVars.usuarioAdministrador
        },

        select2Contato: function () {
            return {entity: 'partcontato/' + this.pedv.codpart, minlength: 0}
        },

        bloqueia_tabela_cliente: function () {
            if (this.pedv.part && this.pedv.part.length > 0 && this.pedv.part[0].codtabpre)
              if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas)
                return this.$store.getters.getParametrosUsuario.vendas.bloqueia_tabela_cliente
              else
                return false
            else
              return false
        },

        tabelas_preco_options: function () {
            //monta objeto de tabelas de preco conforme permissao do usuario (usuario.parametros.vendas.tabelaspreco)
            let options = []

            let liberado = []
            let currTabpre = {}
            let addTabela = false

            for (var x = 0; x < this.$store.getters.getTabpreList.length; x++) {
                currTabpre = this.$store.getters.getTabpreList[x]

                //se existir parametros do usuario, libera somente as tabelas permitidas
                if (this.partCodTabpre && this.partCodTabpre == currTabpre.codtabpre)
                  addTabela = true
                else
                if (this.$store.getters.getParametrosUsuario && this.$store.getters.getParametrosUsuario.vendas) {
                    liberado = this.$store.getters.getParametrosUsuario.vendas.tabelaspreco.filter((obj) => { return obj == currTabpre.codtabpre})
                    if (liberado.length > 0) {
                      addTabela = true
                    }
                } else {
                     addTabela = true
                }

                if (addTabela)
                   options.push({ id: currTabpre.codtabpre, text: currTabpre.descricao })

                addTabela = false
            }

            return options
        },


    },

    filters: {
    },

    methods: {
        closeForm () {
            this.$emit('closeform')
        },

        handleSave () {
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                  this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                  this.validarcampos();
                  if (this.errmessages.errmessages.length == 0){
                      this.$emit('save')
                  }else{
                      this.$erpToastError('Corrigir os erros de validação')
                  }
                }
            })


        },

        closeCustomerForm (id) {
            //ao fechar o formulario de inclusao de clientes
            //if (id) this.pedv.codpart = id
            this.showPartForm = false
        },

        closeVendForm (id) {
            //ao fechar o formulario de inclusao de vendedor
            if (id) this.pedv.codvendr = id
            this.showVendForm = false
        },

        closeContatoForm (id) {
            //ao fechar o formulario de inclusao de vendedor
            if (id) this.pedv.seqcontato = id
            this.showContatoForm = false
        },

        handleIncluirContato () {
            this.showContatoForm = true
        },

        handleIncluir (pTipo) {
            //exibe tela de cadastro
            if (this.isView) {
                return
            }

            if (pTipo === 'part') {
                this.showPartForm = true
            }

            if (pTipo === 'transp') {
                this.showPartForm = true
            }

            if (pTipo === 'vend') {
                this.showPartForm = true
            }

        },

        updateCep () {
            //CARREGA INFORMACOES DO CEP
            this.pedv.endeent = SysVars.endereco.logradouro
            this.pedv.bairroent = SysVars.endereco.bairro
            this.pedv.codmunent = SysVars.endereco.ibge
            this.pedv.ufent = SysVars.endereco.uf
        },

        validarcampos(){
            this.errmessages = {};
            this.errmessages.errmessages = [];

            if (((this.pedv.cepret) || (this.pedv.enderet) || (this.pedv.nomeret) || (this.pedv.endenrret)) && (!this.pedv.cnpjcpfret)){
                this.errmessages.errmessages.push('Cnpj/Cpf Retirada deve ser preenchido.');
            }
            if (((this.pedv.cepret) || (this.pedv.enderet) || (this.pedv.nomeret) || (this.pedv.endenrret)) && (!this.pedv.tppessoaret)){
                this.errmessages.errmessages.push('Tipo Pessoa Retirada deve ser preenchido.');
            }
            if (((this.pedv.cepret) || (this.pedv.enderet) || (this.pedv.nomeret) || (this.pedv.endenrret)) && (!this.pedv.endenrret)){
                this.errmessages.errmessages.push('Nr endereço Retirada deve ser preenchido.');
            }
            if (((this.pedv.cepret) || (this.pedv.enderet) || (this.pedv.nomeret) || (this.pedv.endenrret)) && (!this.pedv.enderet)){
                this.errmessages.errmessages.push('Endereço Retirada deve ser preenchido.');
            }
            if (((this.pedv.cepent) || (this.pedv.endeent) || (this.pedv.nomeent) || (this.pedv.endenrent)) && (!this.pedv.cnpjcpfent)){
                this.errmessages.errmessages.push('Cnpj/Cpf Entrega deve ser preenchido.');
            }
            if (((this.pedv.cepent) || (this.pedv.endeent) || (this.pedv.nomeent) || (this.pedv.endenrent)) && (!this.pedv.tppessoaent)){
                this.errmessages.errmessages.push('Tipo Pessoa Entrega deve ser preenchido.');
            }
            if (((this.pedv.cepent) || (this.pedv.endeent) || (this.pedv.nomeent) || (this.pedv.endenrent)) && (!this.pedv.endenrent)){
                this.errmessages.errmessages.push('Nr endereço Entrega deve ser preenchido.');
            }
            if (((this.pedv.cepent) || (this.pedv.endeent) || (this.pedv.nomeent) || (this.pedv.endenrent)) && (!this.pedv.endeent)){
                this.errmessages.errmessages.push('Endereço Entrega deve ser preenchido.');
            }

        },


    },

    watch: {

    },

    components: {
        CustomerForm, CustomerContatoForm, VendForm

    },

    created () {

    },

    mounted () {
        this.$nextTick(function () {
            this.$refs.contato.$el.querySelector('select').focus()
            // this.$refs.contato.$el.querySelector('input').focus()
            jQuery('[data-toggle="tooltip"]').tooltip()
        })
    }

}

</script>

<template>
    <div class="nb-modal-scrollable">
        <div class="container nb-modal-scrollable-container">
            <div class="nb-modal-header">
                <div class="col-md-12 col-12">
                    <h4 class="def-title" v-if="pedv.tppedv == 'P'">Dados do Pedido ({{ pedv.npedido }}) {{ pedv.part[0].nome }} </h4>
                    <h4 class="def-title" v-if="pedv.tppedv == 'O'">Dados do Orçamento ({{ pedv.ncotacao }}) {{ pedv.part[0].nome }} </h4>
                </div>
            </div>

            <!-- MENSAGENS DE VALIDACAO -->
            <validation v-if="errmessages" title="Erros de Validação" :messages="errmessages.errmessages"></validation>
            <!-- FIM MENSAGENS DE VALIDACAO -->

            <div id="cabec" class="nb-modal-scrollable-body">
                <label-title title="Condições Comerciais"></label-title><br>
                <div class="row">
                    <form-field v-if="!pedv.codnegocio" ref="contato" v-model="pedv.seqcontato" type="select2" col="6" :metadata="metadata.pedv.seqcontato" :disabled="isView"
                        parent="cabec" name="seqcontato" :v-errors="errors" v-validate="metadata.pedv.seqcontato.validator"
                        :select2="select2Contato" :add-button="true" @clickAdd="handleIncluirContato()"></form-field>
                </div>
                <div class="row">
                    <form-field v-model="pedv.pedcli" type="text" col="3" :metadata="metadata.pedv.pedcli"
                        name="pedcli" :v-errors="errors" v-validate="metadata.pedv.pedcli.validator" :disabled="isView"></form-field>
                    <form-field v-model="pedv.codtipo" type="select2" col="3" :metadata="metadata.pedv.codtipo" :disabled="isView"
                        parent="cabec" name="codtipo" :v-errors="errors" v-validate="metadata.pedv.codtipo.validator"></form-field>
                </div>
                <div class="row">
                    <form-field v-model="pedv.finalidade" type="select" col="3" :metadata="metadata.pedv.finalidade" :disabled="isView"></form-field>
                    <form-field v-if="!bloqueia_tabela_cliente" v-model="pedv.codtabpre" type="select2" col="3" :metadata="metadata.pedv.codtabpre"
                        :select-options="tabelas_preco_options" :disabled="isView"
                        parent="cabec" name="codtabpre" :v-errors="errors" v-validate="metadata.pedv.codtabpre.validator"></form-field>
                    <div class="col-md-3 col-6" v-else>
                        <v-label class="w-100" :metadata-field="metadata.pedv.codtabpre"></v-label>
                        <div class="lbl" v-if="pedv.tabpre && pedv.tabpre.length">{{ pedv.tabpre[0].descricao }}</div>
                    </div>
                </div>
                <div class="row">
                    <form-field v-model="pedv.prazodias" type="number" col="2" :metadata="metadata.pedv.prazodias" :disabled="isView"
                        name="prazodias" :v-errors="errors" v-validate="metadata.pedv.prazodias.validator"></form-field>
                    <form-field v-model="pedv.prazo" type="date" col="2" :metadata="metadata.pedv.prazo" :disabled="isView"
                        name="prazo" :v-errors="errors" v-validate="metadata.pedv.prazo.validator"></form-field>
                    <form-field v-model="pedv.validadedias" type="number" col="2" :metadata="metadata.pedv.validadedias" :disabled="isView"
                        name="validadedias" :v-errors="errors" v-validate="metadata.pedv.validadedias.validator"></form-field>
                    <form-field v-model="pedv.dtvalidade" type="date" col="2" :metadata="metadata.pedv.dtvalidade" :disabled="isView"
                        name="dtvalidade" :v-errors="errors" v-validate="metadata.pedv.dtvalidade.validator"></form-field>
                </div>


                <div v-if="(pedv.tppedv == 'O' || pedv.tppedv == 'P') && pedv.venda == 'S'">
                    <label-title title="Comissão"></label-title><br>
                    <div class="row">
                        <form-field v-model="pedv.codvendr" type="select2" col="3" :metadata="metadata.pedv.codvendr" :disabled="isView"
                            name="codvendr" :v-errors="errors" v-validate="metadata.pedv.codvendr.validator"
                            :add-button="true" @clickAdd="handleIncluir('vend')"></form-field>
                        <form-field v-model="pedv.pcomir" type="value" col="3" :metadata="metadata.pedv.pcomir" :precision="2" :disabled="isView"
                            name="pcomir" :v-errors="errors" v-validate="metadata.pedv.pcomir.validator"></form-field>
                        <form-field v-model="pedv.codvend2" type="select2" col="3" :metadata="metadata.pedv.codvend2" :disabled="isView"
                            name="codvend2" :v-errors="errors" v-validate="metadata.pedv.codvend2.validator"
                            :add-button="true" @clickAdd="handleIncluir('vend')"></form-field>
                        <form-field v-model="pedv.pcomi2" type="value" col="3" :metadata="metadata.pedv.pcomi2" :precision="2" :disabled="isView"
                            name="pcomi2" :v-errors="errors" v-validate="metadata.pedv.pcomi2.validator"></form-field>
                    </div>
                </div>



                <label-title title="Transporte"></label-title>
                <div class="row">
                    <form-field v-model="pedv.codparttr" type="select2" col="4" :metadata="metadata.pedv.codparttr" :disabled="isView"
                        parent="cabec" name="codparttr" :v-errors="errors" v-validate="metadata.pedv.codparttr.validator"
                        :add-button="true" @clickAdd="handleIncluir('transp')"></form-field>
                </div>
                <div class="row">
                    <form-field v-model="pedv.vlrfre" type="value" col="2" :metadata="metadata.pedv.vlrfre" :disabled="isView" preaddon="R$"
                        name="vlrfre" :v-errors="errors" v-validate="metadata.pedv.vlrfre.validator"></form-field>
                    <!-- <form-field v-model="pedv.vlrseg" type="value" col="2" :metadata="metadata.pedv.vlrseg" :disabled="isView" preaddon="R$"
                        name="vlrseg" :v-errors="errors" v-validate="metadata.pedv.vlrseg.validator"></form-field>
                    <form-field v-model="pedv.vlrdesp" type="value" col="2" :metadata="metadata.pedv.vlrdesp" :disabled="isView" preaddon="R$"
                        name="vlrdesp" :v-errors="errors" v-validate="metadata.pedv.vlrdesp.validator"></form-field> -->
                </div>
                <!-- <div class="row">
                    <form-field v-model="pedv.pliq" type="value" col="2" :metadata="metadata.pedv.pliq" :disabled="isView" addon="Kg"
                        name="pliq" :v-errors="errors" v-validate="metadata.pedv.pliq.validator"></form-field>
                    <form-field v-model="pedv.pbru" type="value" col="2" :metadata="metadata.pedv.pbru" :disabled="isView" addon="Kg"
                        name="pbru" :v-errors="errors" v-validate="metadata.pedv.pbru.validator"></form-field>
                    <form-field v-model="pedv.qtvolumes" type="value" col="2" :metadata="metadata.pedv.qtvolumes" :disabled="isView"
                        name="qtvolumes" :v-errors="errors" v-validate="metadata.pedv.qtvolumes.validator"></form-field>
                </div> -->
                <label-title title="Endereço de Entrega"></label-title>
                <div class="row">
                    <form-field v-model="pedv.nomeent" type="text" col="4" :metadata="metadata.pedv.nomeent" :disabled="isView"
                        name="nomeent" :v-errors="errors" v-validate="metadata.pedv.nomeent.validator"></form-field>
                    <form-field v-model="pedv.emailent" type="email" col="4" :metadata="metadata.pedv.emailent" :disabled="isView"
                        name="emailent" :v-errors="errors" v-validate="metadata.pedv.emailent.validator"></form-field>
                    <form-field v-model="pedv.foneent" type="fone" col="2" :metadata="metadata.pedv.foneent" :disabled="isView"
                        name="foneent" :v-errors="errors" v-validate="metadata.pedv.foneent.validator"></form-field>
                    <form-field v-model="pedv.cepent" type="cep" col="2" :metadata="metadata.pedv.cepent" :disabled="isView"
                        name="cepent" :v-errors="errors" v-validate="metadata.pedv.cepent.validator" @update="updateCep"></form-field>
                    <form-field v-model="pedv.endeent" type="text" col="4" :metadata="metadata.pedv.endeent" :disabled="isView"
                        name="endeent" :v-errors="errors" v-validate="metadata.pedv.endeent.validator"></form-field>
                    <form-field v-model="pedv.endenrent" type="text" col="2" :metadata="metadata.pedv.endenrent" :disabled="isView"
                        name="endenrent" :v-errors="errors" v-validate="metadata.pedv.endenrent.validator"></form-field>
                    <form-field v-model="pedv.endecompent" type="text" col="4" :metadata="metadata.pedv.endecompent" :disabled="isView"
                        name="endecompent" :v-errors="errors" v-validate="metadata.pedv.endecompent.validator"></form-field>
                    <form-field v-model="pedv.bairroent" type="text" col="4" :metadata="metadata.pedv.bairroent" :disabled="isView"
                        name="bairroent" :v-errors="errors" v-validate="metadata.pedv.bairroent.validator"></form-field>
                    <form-field v-model="pedv.ufent" type="select2" col="4" :metadata="metadata.pedv.ufent" :disabled="isView"
                        parent="cabec" name="ufent" :v-errors="errors" v-validate="metadata.pedv.ufent.validator"></form-field>
                    <form-field v-model="pedv.codmunent" type="select2" col="4" :metadata="metadata.pedv.codmunent" :disabled="isView"
                        parent="cabec" name="codmunent" :v-errors="errors" v-validate="metadata.pedv.codmunent.validator"
                        :select2="{entity: 'mun/uf/' + pedv.ufent, minlength: 2}"></form-field>
                    <form-field v-model="pedv.codpaisent" type="select2" col="3" :metadata="metadata.pedv.codpaisent"
                        parent="cabec" name="codpaisent" :v-errors="errors" v-validate="metadata.pedv.codpaisent.validator" :disabled="isView"></form-field>
                    <form-field v-model="pedv.tppessoaent" type="select" col="2" :metadata="metadata.pedv.tppessoaent" :disabled="isView"></form-field>
                    <form-field v-if="pedv.tppessoaent=='F'" v-model="pedv.cnpjcpfent" type="number" col="3" :metadata="metadata.pedv.cnpjcpfent" :disabled="isView"
                        name="cpf" :v-errors="errors" v-validate="{cpf: true, required: true, numeric: true, min: 11, max: 11}"></form-field>
                    <form-field v-if="pedv.tppessoaent=='J'" v-model="pedv.cnpjcpfent" type="number" col="3" :metadata="metadata.pedv.cnpjcpfent" :disabled="isView"
                        name="cnpj" :v-errors="errors" v-validate="{cnpj: true, required: true, numeric: true, min: 14, max: 14}"></form-field>
                    <form-field v-if="pedv.tppessoaent=='J'" v-model="pedv.iestent" :metadata="metadata.pedv.iestent" type="text" col="4" :disabled="isView"
                        name="iestent" :v-errors="errors" v-validate="metadata.pedv.iestent.validator"></form-field>
                </div>

                <div v-if="administrador && metadata.pedv.codusuario.select2 && metadata.pedv.codusuario.select2.entity">
                    <label-title title="Usuario vinculado ao pedido"></label-title><br>
                    <div class="row">
                        <form-field v-model="pedv.codusuario" type="select2" col="3" :metadata="metadata.pedv.codusuario" :disabled="isView"
                            name="codusuario" :v-errors="errors" v-validate="metadata.pedv.codusuario.validator"></form-field>
                    </div>
                </div>

               <label-title title="Observações"></label-title>
                <div class="row">
                    <form-field v-model="pedv.obspedido" type="memo" col="6" :metadata="metadata.pedv.obspedido" :disabled="isView"
                        name="obspedido" :v-errors="errors" v-validate="metadata.pedv.obspedido.validator"></form-field>
                </div>
                <!-- <div style="white-space: pre-line">
                    {{pedv.obspedido}}
                </div> -->
                <div class="row">
                    <form-field v-model="pedv.obslog" type="memo" col="6" label="Observação Interna" :disabled="isView"
                        name="obslog" :v-errors="errors" v-validate="metadata.pedv.obslog.validator"></form-field>
                </div>
                <div class="nb-modal-scrollable-footer">
                    <v-button v-show="!isView" label="Salvar" title="" :nb-btdef="true" @click="handleSave"></v-button>
                    <v-button v-show="!isView" label="Cancelar" title="" @click="closeForm"></v-button>
                    <v-button v-show="isView" label="Fechar" title="" @click="closeForm"></v-button>
                </div>
            </div>
        </div>

<!-- CADASTRO DO CONTATO -->
        <div v-if="showContatoForm">
            <customer-contato-form crud="ins" :codpart="pedv.codpart" @closeform="closeContatoForm"></customer-contato-form>
        </div>
<!-- FIM CADASTRO DO CONTATO -->

<!-- CADASTRO DE PARTICIPANTE -->
        <div class="nb-modal-scrollable" v-if="showPartForm">
            <div class="container nb-modal-scrollable-container">
                <div class="nb-modal-scrollable-body">
                    <customer-form crud="ins" @closeform="closeCustomerForm"></customer-form>
                </div>
            </div>
        </div>

<!-- FIM CADASTRO DE PARTICIPANTE -->

<!-- CADASTRO DE VENDEDOR -->
        <div class="nb-modal-scrollable" v-if="showVendForm">
            <div class="container nb-modal-scrollable-container">
                <div class="nb-modal-scrollable-body">
                    <vend-form crud="ins" @closeform="closeVendForm"></vend-form>
                </div>
            </div>
        </div>
<!-- FIM CADASTRO DE VENDEDOR -->
    </div>


</template>




// WEBPACK FOOTER //
// src/forms-fv/fv-pedido-form-infcpl.vue